<template>
  <div class="flex flex-col gap-[3px]">
    <div v-for="(row, i) of grid" :key="i" class="flex items-center gap-[3px]">
      <span class="w-4 shrink-0 text-[10px] font-semibold text-gray-400">{{ dayLetters[i] }}</span>
      <div
        v-for="(v, j) of row"
        :key="j"
        class="flex-1 h-[15px] rounded"
        :style="{background: v === 0 ? '#f4f4f5' : `rgba(136,100,238,${0.22 + (v / max) * 0.78})`}"/>
    </div>
    <div class="flex gap-[3px] mt-0.5">
      <span class="w-4 shrink-0"/>
      <span v-for="h of hourLabels" :key="h" class="flex-1 text-[9px] text-gray-400 text-center">{{ h }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import type {IAnalyticsHeatmapCell} from '@torim-app/types';

const props = defineProps<{ heatmap: IAnalyticsHeatmapCell[] }>();

const dayLetters = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];
const hourLabels = ['8', '10', '12', '14', '16', '18', '20'];

// 7 weekdays × 7 two-hour buckets (8:00 → 21:59; earlier hours fold into the first bucket)
const grid = computed(() => {
  const rows = Array.from({length: 7}, () => new Array(7).fill(0));
  for (const cell of props.heatmap) {
    const bucket = Math.min(Math.max(Math.floor((cell.hour - 8) / 2), 0), 6);
    if (cell.weekday >= 0 && cell.weekday <= 6) rows[cell.weekday][bucket] += cell.value;
  }
  return rows;
});

const max = computed(() => Math.max(...grid.value.flat(), 1));
</script>
